import axios from 'axios'
import { setInterceptors } from '@api/config/interceptors'

const BASE_URL = 'https://learn.programmers.co.kr/'

function create(url, options) {
  const instance = axios.create({ baseURL: url, ...options })
  setInterceptors(false, instance)
  return instance
}

function createWithAuth(url, options) {
  const instance = axios.create({ baseURL: url, ...options })
  setInterceptors(true, instance)
  return instance
}

export const instance = create(BASE_URL)
export const auth = createWithAuth(BASE_URL)
